const INITIAL_STATE = {
  name: '',
  selected: 0
};

export const eventsCheckinReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'UPDATE_EVENTS_CHECKIN_NAME':
      return {
        ...state,
        name: action.payload
      };
    case 'UPDATE_EVENTS_CHECKIN_SELECTED':
      return {
        ...state,
        selected: action.payload
      };
    case 'CLEAR_EVENTS_CHECKIN_SELECTED':
      return {
        ...state,
        name: '',
        selected: 0
      };
    default:
      return state;
  }
};
